export default "__VITE_ASSET__D980JJXc__"